import { rj } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import api from "../api"
import { PAGE_SIZE } from "../consts"

export const PrestazioneState = rj(
  rjList({
    pagination: nextPreviousPaginationAdapter,
    pageSize: PAGE_SIZE,
  }),
  {
    mutations: {
      removeServizio: {
        effect: (t) => (entity) =>
          api
            .auth(t)
            .mapResponse(() => entity)
            .delete(`/api/prestazioni/${entity.id}`),
        updater: "deleteItem",
        // Uncomment to make delete optimistic
        // optimistiResult: entity => entity,
      },
      addServizio: {
        effect: (t) => (entity) => api.auth(t).post("/api/prestazioni", entity),
        updater: "insertItem",
      },
      updateServizio: {
        effect: (t) => (entity) =>
          api.auth(t).put(`/api/prestazioni/${entity.id}/`, entity),
        updater: "updateItem",
      },
    },
    name: "PrestazioneState",
    effectCaller: "configured",
    effect: (t) => (params = {}) => api.auth(t).get("/api/prestazioni", params),
    computed: {
      pagination: "getPagination",
      list: "getList",
      loading: "isLoading",
    },
  }
)
